import { AxiosRequestConfig } from 'axios';
import { apiClient, IReqOptions } from 'common/clients/api.client.ts';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants.ts';
import { EApiPathParams } from 'common/enums/api-path-params.enums.ts';
import {
  ITransactionsDataRes,
  ITransactionDataRes,
  ITransactionRefundRes,
  ITransactionsDataParams,
  ITransactionsCountRes,
  ITransactionInfoDataRes,
  IConfirmTravelRuleRes,
} from 'domains/transaction/interfaces/transaction.interfaces.ts';
import { TTransactionsCountReqParams } from 'domains/transaction/types/transaction.type.ts';

export const getTransactionsDataService = async ({
  pageParam,
  reqParams,
  reqOptions,
}: {
  pageParam: number,
  reqParams: ITransactionsDataParams,
  reqOptions?: IReqOptions,
}): Promise<ITransactionsDataRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.TRANSACTIONS;
  const config = {
    ...reqOptions,
    params: {
      ...reqParams,
      offset: pageParam,
    },
  };

  const res = await apiClient.get<ITransactionsDataRes>(url, config);

  return res.data;
};

export const countTransactionsService = async (
  params: TTransactionsCountReqParams
): Promise<ITransactionsCountRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.TRANSACTIONS_COUNT;
  const config = {
    params,
  };

  const res = await apiClient.get<ITransactionsCountRes>(url, config);

  return res.data;
};

export const getTransactionDataService = async ({
  sep24GUID,
  reqOptions,
}: {
  sep24GUID: string;
  reqOptions?: IReqOptions;
}): Promise<ITransactionDataRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.TRANSACTION.replace(EApiPathParams.Sep24GUID, sep24GUID);
  const config = {
    ...reqOptions,
  } as AxiosRequestConfig;
  const res = await apiClient.get<ITransactionDataRes>(url, config);

  return res.data;
};

export const getTransactionInfoDataService = async ({
  sep24GUID,
  reqOptions,
}: {
  sep24GUID: string;
  reqOptions?: IReqOptions;
}): Promise<ITransactionInfoDataRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.TRANSACTION_INFO.replace(EApiPathParams.Sep24GUID, sep24GUID);
  const config = {
    ...reqOptions,
  } as AxiosRequestConfig;
  const res = await apiClient.get<ITransactionInfoDataRes>(url, config);

  return res.data;
};

export const postTransactionRefundService = async (
  sep24GUID: string,
): Promise<ITransactionRefundRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.REFUND.replace(EApiPathParams.Sep24GUID, sep24GUID);
  const res = await apiClient.put<ITransactionRefundRes>(url);

  return res.data;
};

export const postConfirmTravelRuleService = async (
  sep24GUID: string,
): Promise<IConfirmTravelRuleRes> => {
  const url = API_ENDPOINTS.TRANSACTIONS.CONFIRM_TRAVEL_RULE.replace(EApiPathParams.Sep24GUID, sep24GUID);
  const res = await apiClient.post<IConfirmTravelRuleRes>(url, { confirm_travel_rule: true });

  return res.data;
};
